import { Box, Stack, TextField } from '@mui/material';
import { grey } from '@mui/material/colors';
import { memo } from 'react';
import PropTypes from 'prop-types';

const AppVersion = ({
  title,
  fieldKey,
  errorText,
  valueText,
  setFieldValue,
  disabled = false,
}) => {
  return (
    <Stack direction='column' spacing={2}>
      <Box component='p' color='text.primary' fontSize={14}>
        {title}
        {!disabled && (
          <Box component='span' ml={1} sx={{ color: 'error.main' }}>
            *
          </Box>
        )}
      </Box>
      <TextField
        disabled={disabled}
        fullWidth
        placeholder='1.0.0'
        error={!!errorText}
        helperText={errorText}
        value={valueText ?? ''}
        onChange={async (e) => {
          setFieldValue(fieldKey, e.target.value);
        }}
        onBlur={(e) => {
          setFieldValue(fieldKey, valueText?.trim());
        }}
        sx={{ '& .Mui-disabled': { backgroundColor: grey[50] } }}
      />
    </Stack>
  );
};

export default memo(AppVersion);

AppVersion.propTypes = {
  title: PropTypes.string,
  fieldKey: PropTypes.string,
  errorText: PropTypes.string,
  valueText: PropTypes.string,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
};
